import { useRef, useState } from "react";
import { Loader2, Paperclip, FolderOpen, Camera, UploadCloud } from "lucide-react";
import { droppedFiles, pickedFiles } from "../lib/files";

export function UploadZone({ onFiles, accept, label, testid, multiple = true, folder = true, camera = true, progress }) {
  const fileRef = useRef();
  const dirRef = useRef();
  const camRef = useRef();
  const [over, setOver] = useState(false);
  const busy = !!progress;
  const run = (list) => { if (list.length) onFiles(multiple ? list : list.slice(0, 1)); };
  const pick = (e) => { const l = pickedFiles(e); e.target.value = ""; run(l); };
  const drop = async (e) => { e.preventDefault(); setOver(false); if (!busy) run(await droppedFiles(e)); };
  return (
    <div onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)} onDrop={drop}
      className={`rounded-xl border-2 border-dashed p-2 transition-colors ${over ? "border-amber-500 bg-amber-50" : "border-slate-300"}`} data-testid={testid}>
      <input ref={fileRef} type="file" hidden multiple={multiple} accept={accept} onChange={pick} data-testid={`${testid}-input`} />
      <input ref={dirRef} type="file" hidden webkitdirectory="" directory="" multiple onChange={pick} data-testid={`${testid}-folder-input`} />
      <input ref={camRef} type="file" hidden accept="image/*" capture="environment" onChange={pick} data-testid={`${testid}-camera-input`} />
      <div className="flex flex-wrap gap-2">
        <button type="button" className="tl-btn tl-btn-ghost flex-1 min-w-[140px]" onClick={() => fileRef.current.click()} disabled={busy} data-testid={`${testid}-button`}>
          {busy ? <Loader2 className="animate-spin" size={18} /> : <Paperclip size={18} />} {busy ? `Envoi ${progress}` : label}
        </button>
        {folder && multiple && (
          <button type="button" className="tl-btn tl-btn-ghost" onClick={() => dirRef.current.click()} disabled={busy} data-testid={`${testid}-folder-button`}><FolderOpen size={18} /> Dossier</button>
        )}
        {camera && (
          <span className="sm:hidden"><button type="button" className="tl-btn tl-btn-ghost" onClick={() => camRef.current.click()} disabled={busy} data-testid={`${testid}-camera-button`}><Camera size={18} /> Photo</button></span>
        )}
      </div>
      <p className="hidden sm:flex items-center gap-1 text-xs text-slate-500 mt-1"><UploadCloud size={14} /> Ou glissez ici des fichiers, un dossier ou un ZIP</p>
    </div>
  );
}
